import React from 'react';
import wa from '../../assets/Request-Pickup-Pantja-Laundry.png';
import maps from '../../assets/Maps-Pantja-Laundry.jpg';

import "animate.css/animate.min.css";
import { AnimationOnScroll } from 'react-animation-on-scroll';
import './contact.css';

import { RiMapPinLine } from 'react-icons/ri';

const Contact = () => {
  return (
    <div className='pl__contact section__padding' id='contact'>
      <div className='pl__contact-content'>
        <h1 className='gradient__text'>Feel Free...<br />Hubungi Layanan Pickup Kami berikut ini</h1>
        <div className='pl__contact-content_wa'>
          <AnimationOnScroll animateIn="animate__pulse animate__infinite infinite">
            <a href="https://wa.me/6282113629874?text=Halo%20Pantja%20Laundry" rel="noopener noreferrer">
              <img src={wa} alt="Request Pickup Pantja Laundry" />
            </a>
          </AnimationOnScroll>
        </div>
        <p>Syarat & Ketentuan FREE Pickup berlaku untuk maksimal jarak 5Km dari lokasi dan minimal cucian +- 10 Kilogram.</p>
      </div>
      <div className='pl__contact-maps'>
        <a href="https://goo.gl/maps/c2TFgQ25ueWXpMrf8" rel="external">
          <img src={maps} alt="Maps Pantja Laundry" />
        </a>
        <p><RiMapPinLine size={20} />Lihat di Google Maps</p>
      </div>
    </div>
  )
}

export default Contact